import { render } from "./AppModal.vue?vue&type=template&id=3f2979be&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=3f2979be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f2979be"

export default script